<template>
  <q-page class="form-page">
    <!-- Page header -->
    <div class="page-header">
      <div class="page-header-inner">
        <q-btn
          flat
          round
          dense
          icon="arrow_back"
          class="back-btn"
          @click="confirmCancel"
        />
        <div class="q-ml-md">
          <div class="page-title">
            {{ isEditing ? "Editar Imóvel" : "Publicar Imóvel" }}
          </div>
          <div class="page-subtitle">
            {{
              isEditing
                ? "Actualize os dados do seu imóvel"
                : "Preencha os dados do imóvel para publicação"
            }}
          </div>
        </div>
      </div>
    </div>

    <!-- Form card -->
    <div class="form-wrapper">
      <q-card flat class="form-card">
        <q-stepper
          v-model="step"
          ref="stepperRef"
          flat
          animated
          :contracted="isMobile"
          class="property-stepper"
        >
          <!-- ── STEP 1: Informações Básicas ── -->
          <q-step
            :name="1"
            title="Informações Básicas"
            icon="info"
            :done="step > 1"
          >
            <q-form ref="step1FormRef" class="section-body">
              <q-input
                v-model="form.title"
                label="Título do imóvel"
                placeholder="Ex: Vivenda T4 com piscina em Sommerschield"
                outlined
                class="form-field"
                lazy-rules
                :rules="[
                  (val) => (val && val.length > 0) || 'Título é obrigatório',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="title" color="grey-5" />
                </template>
              </q-input>

              <!-- <q-input
                v-model="form.description"
                label="Descrição"
                placeholder="Descreva os detalhes mais atractivos do imóvel..."
                type="textarea"
                rows="4"
                outlined
                class="form-field"
                lazy-rules
                :rules="[
                  (val) => (val && val.length > 0) || 'Descrição é obrigatória',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="notes" color="grey-5" />
                </template>
              </q-input> -->

              <!-- <div class="q-pa-md q-gutter-sm"> -->
              <q-field
                :model-value="form.description"
                label="Descrição"
                outlined
                stack-label
                class="form-field description-field"
                lazy-rules
                :rules="[descriptionRule]"
              >
                <template v-slot:control>
                  <q-editor
                    v-model="form.description"
                    class="description-editor"
                    :dense="$q.screen.lt.md"
                    :toolbar="[
                      [
                        {
                          icon: $q.iconSet.editor.formatting,
                          list: 'no-icons',
                          options: [
                            'p',
                            'h1',
                            'h2',
                            'h3',
                            'h4',
                            'h5',
                            'h6',
                            'code',
                          ],
                        },
                        {
                          icon: $q.iconSet.editor.fontSize,
                          fixedLabel: true,
                          fixedIcon: true,
                          list: 'no-icons',
                          options: [
                            'size-1',
                            'size-2',
                            'size-3',
                            'size-4',
                            'size-5',
                            'size-6',
                            'size-7',
                          ],
                        },
                        {
                          icon: $q.iconSet.editor.font,
                          fixedIcon: true,
                          list: 'no-icons',
                          options: [
                            'default_font',
                            'arial',
                            'arial_black',
                            'comic_sans',
                            'courier_new',
                            'impact',
                            'lucida_grande',
                            'times_new_roman',
                            'verdana',
                          ],
                        },
                        'removeFormat',
                        {
                          icon: $q.iconSet.editor.align,
                          fixedLabel: true,
                          list: 'only-icons',
                          options: ['left', 'center', 'right', 'justify'],
                        },
                        'bold',
                        'italic',
                        'strike',
                        'underline',
                        'subscript',
                        'superscript',
                        'token',
                        'hr',
                        'link',
                        'custom_btn',
                        'fullscreen',
                        'quote',
                        'unordered',
                        'ordered',
                        'outdent',
                        'indent',
                        'undo',
                        'redo',
                      ],
                    ]"
                    :fonts="{
                      arial: 'Arial',
                      arial_black: 'Arial Black',
                      comic_sans: 'Comic Sans MS',
                      courier_new: 'Courier New',
                      impact: 'Impact',
                      lucida_grande: 'Lucida Grande',
                      times_new_roman: 'Times New Roman',
                      verdana: 'Verdana',
                    }"
                  />
                </template>
              </q-field>
              <!-- </div> -->

              <div style="padding-bottom: 2px"><p></p></div>

              <div class="row q-col-gutter-md">
                <div class="col-12 col-sm-6">
                  <q-select
                    v-model="form.property_type_id"
                    :options="propertyTypes"
                    label="Tipo de Imóvel"
                    option-value="id"
                    option-label="name"
                    emit-value
                    map-options
                    outlined
                    class="form-field"
                    lazy-rules
                    :rules="[(val) => val !== null || 'Selecione o tipo']"
                  >
                    <template v-slot:prepend>
                      <q-icon name="home_work" color="grey-5" />
                    </template>
                  </q-select>
                </div>
                <div class="col-12 col-sm-6">
                  <q-input
                    v-model="form.location"
                    label="Localização"
                    placeholder="Ex: Maputo, Sommerschield"
                    outlined
                    class="form-field"
                    lazy-rules
                    :rules="[
                      (val) =>
                        (val && val.length > 0) || 'Localização é obrigatória',
                    ]"
                  >
                    <template v-slot:prepend>
                      <q-icon name="location_on" color="grey-5" />
                    </template>
                  </q-input>
                </div>
              </div>
            </q-form>

            <div class="form-actions form-actions--step">
              <q-btn
                flat
                label="Cancelar"
                class="action-btn action-btn--cancel"
                @click="confirmCancel"
              />
              <q-btn
                label="Continuar"
                unelevated
                icon-right="arrow_forward"
                :loading="savingStep1"
                class="action-btn action-btn--submit"
                @click="onContinueStep1"
              />
            </div>
          </q-step>

          <!-- ── STEP 2: Preço & Características ── -->
          <q-step
            :name="2"
            title="Preço & Características"
            icon="tune"
            :done="step > 2"
          >
            <q-form ref="step2FormRef" class="section-body">
              <div class="row q-col-gutter-md">
                <div class="col-12 col-sm-8">
                  <q-input
                    v-model.number="form.price"
                    label="Preço"
                    type="number"
                    min="0"
                    outlined
                    class="form-field"
                    lazy-rules
                    :rules="[(val) => val > 0 || 'Preço inválido']"
                  >
                    <template v-slot:prepend>
                      <q-icon name="payments" color="grey-5" />
                    </template>
                  </q-input>
                </div>
                <div class="col-12 col-sm-4">
                  <q-select
                    v-model="form.currency"
                    :options="currencies"
                    label="Moeda"
                    outlined
                    class="form-field"
                    lazy-rules
                    :rules="[(val) => !!val || 'Obrigatório']"
                  />
                </div>
              </div>

              <q-input
                v-model.number="form.area"
                label="Área"
                type="number"
                min="0"
                suffix="m²"
                outlined
                class="form-field"
                lazy-rules
                :rules="[(val) => val >= 0 || 'Área inválida']"
              >
                <template v-slot:prepend>
                  <q-icon name="square_foot" color="grey-5" />
                </template>
              </q-input>

              <div class="row q-col-gutter-md">
                <div class="col-6 col-sm-4">
                  <q-input
                    v-model.number="form.bedroom_amount"
                    label="Quartos"
                    type="number"
                    min="0"
                    outlined
                    class="form-field"
                    lazy-rules
                    :rules="[(val) => val >= 0 || 'Inválido']"
                  >
                    <template v-slot:prepend>
                      <q-icon name="bed" color="grey-5" />
                    </template>
                  </q-input>
                </div>
                <div class="col-6 col-sm-4">
                  <q-input
                    v-model.number="form.bathroom_amount"
                    label="Banheiros"
                    type="number"
                    min="0"
                    outlined
                    class="form-field"
                    lazy-rules
                    :rules="[(val) => val >= 0 || 'Inválido']"
                  >
                    <template v-slot:prepend>
                      <q-icon name="bathtub" color="grey-5" />
                    </template>
                  </q-input>
                </div>
                <div class="col-12 col-sm-4">
                  <q-input
                    v-model.number="form.garage_space"
                    label="Garagem"
                    type="number"
                    min="0"
                    outlined
                    class="form-field"
                    lazy-rules
                    :rules="[(val) => val >= 0 || 'Inválido']"
                  >
                    <template v-slot:prepend>
                      <q-icon name="garage" color="grey-5" />
                    </template>
                  </q-input>
                </div>
              </div>

              <div class="row q-col-gutter-md">
                <div class="col-12 col-sm-6">
                  <q-select
                    v-model="form.condition_id"
                    :options="conditions"
                    label="Condição"
                    option-value="id"
                    option-label="name"
                    emit-value
                    map-options
                    outlined
                    class="form-field"
                    lazy-rules
                    :rules="[(val) => val !== null || 'Selecione a condição']"
                  >
                    <template v-slot:prepend>
                      <q-icon name="star_rate" color="grey-5" />
                    </template>
                  </q-select>
                </div>
                <div class="col-12 col-sm-6">
                  <q-select
                    v-model="form.objective_id"
                    :options="objectives"
                    label="Objetivo"
                    option-value="id"
                    option-label="name"
                    emit-value
                    map-options
                    outlined
                    class="form-field"
                    lazy-rules
                    :rules="[(val) => val !== null || 'Selecione o objetivo']"
                  >
                    <template v-slot:prepend>
                      <q-icon name="sell" color="grey-5" />
                    </template>
                  </q-select>
                </div>
              </div>
            </q-form>

            <div class="form-actions form-actions--step">
              <q-btn
                flat
                label="Voltar"
                icon="arrow_back"
                class="action-btn action-btn--reset"
                @click="step = 1"
              />
              <q-btn
                flat
                label="Cancelar"
                class="action-btn action-btn--cancel"
                @click="confirmCancel"
              />
              <q-btn
                label="Continuar"
                unelevated
                icon-right="arrow_forward"
                :loading="savingStep2"
                class="action-btn action-btn--submit"
                @click="onContinueStep2"
              />
            </div>
          </q-step>

          <!-- ── STEP 3: Imagens ── -->
          <q-step :name="3" title="Imagens" icon="photo_library">
            <div class="section-body">
              <div class="section-sub q-mb-md">
                {{ imagesPreviews.length }}/10 imagens adicionadas
              </div>

              <div
                class="upload-zone"
                :class="{ 'upload-zone--disabled': form.images.length >= 10 }"
              >
                <q-file
                  v-model="tempImage"
                  multiple
                  append
                  accept="image/jpeg,image/png,image/jpg,image/webp"
                  max-file-size="5242880"
                  :max-files="10"
                  :disable="form.images.length >= 10"
                  @update:model-value="onImageSelected"
                  @rejected="onRejected"
                  class="upload-input"
                  borderless
                >
                  <template v-slot:default>
                    <div class="upload-prompt">
                      <q-icon
                        name="add_photo_alternate"
                        size="40px"
                        class="upload-icon"
                      />
                      <div class="upload-text">
                        {{
                          form.images.length >= 10
                            ? "Limite de 10 imagens atingido"
                            : "Clique para adicionar imagem"
                        }}
                      </div>
                      <div class="upload-hint">
                        JPEG, PNG, WEBP — máx. 5 MB por imagem
                      </div>
                    </div>
                  </template>
                </q-file>
              </div>

              <div
                v-if="showImageError && form.images.length === 0"
                class="text-negative text-caption q-mt-sm"
              >
                Adicione pelo menos 1 imagem
              </div>

              <div v-if="imagesPreviews.length > 0" class="q-mt-lg">
                <div class="row q-col-gutter-md">
                  <div
                    v-for="(item, index) in imagesPreviews"
                    :key="index"
                    class="col-6 col-sm-4 col-md-3"
                  >
                    <div class="preview-card">
                      <q-img :src="item.url" ratio="1" class="preview-img" />
                      <div class="preview-overlay">
                        <q-btn
                          round
                          dense
                          icon="delete"
                          color="negative"
                          size="sm"
                          @click="removeImage(index)"
                        />
                      </div>
                      <div class="preview-label">{{ item.name }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-actions form-actions--step">
              <q-btn
                flat
                label="Voltar"
                icon="arrow_back"
                class="action-btn action-btn--reset"
                @click="step = 2"
              />
              <q-btn
                flat
                label="Cancelar"
                class="action-btn action-btn--cancel"
                @click="confirmCancel"
              />
              <q-btn
                :label="isEditing ? 'Guardar alterações' : 'Publicar Imóvel'"
                unelevated
                :loading="publishing"
                class="action-btn action-btn--submit"
                @click="onPublish"
              >
                <template v-slot:loading>
                  <q-spinner-dots />
                </template>
              </q-btn>
            </div>
          </q-step>
        </q-stepper>
      </q-card>
    </div>

    <q-inner-loading
      :showing="loader"
      label="Por favor, aguarde..."
      label-class="text-primary"
      label-style="font-size: 1em"
    />
  </q-page>
</template>

<script>
import store from "@/vuex/store";
import { ref, computed, onBeforeUnmount, onMounted } from "vue";
import { useQuasar } from "quasar";
import Swal from "sweetalert2";
import router from "@/router";
import { useRoute } from "vue-router";

export default {
  name: "PropertyFormStepper",

  // Confirma a saída quando existe um formulário guardado localmente.
  async beforeRouteLeave(to, from, next) {
    if (!this.hasLocalDraft) {
      next();
      return;
    }

    const result = await Swal.fire({
      icon: "warning",
      title: "Descartar este imóvel?",
      text: "Tudo o que preencheu até agora será apagado permanentemente.",
      showCancelButton: true,
      confirmButtonText: "Sim, descartar",
      cancelButtonText: "Ficar na página",
      confirmButtonColor: "#d33",
    });

    if (!result.isConfirmed) {
      next(false);
      return;
    }

    localStorage.removeItem(this.storageKey);
    next();
  },

  setup() {
    const $q = useQuasar();
    const route = useRoute();
    // Em ecrãs pequenos mostramos só o círculo/ícone no cabeçalho do
    // stepper (sem o texto, que era o que estava a quebrar linha de
    // forma estranha no mobile).
    const isMobile = computed(() => $q.screen.lt.sm);
    const editor = ref("What you see is <b>what</b> you get.");

    const step = ref(1);
    const propertySlug = computed(() => route.params.slug || null);
    const isEditing = computed(() => Boolean(propertySlug.value));
    const stepperRef = ref(null);
    const step1FormRef = ref(null);
    const step2FormRef = ref(null);

    const savingStep1 = ref(false);
    const savingStep2 = ref(false);
    const publishing = ref(false);
    const loader = ref(false);

    const tempImage = ref([]);
    const showImageError = ref(false);
    const legacyStorageKey = "goldenkey-property-form";
    const tabIdKey = "goldenkey-property-form-tab-id";
    const tabId =
      sessionStorage.getItem(tabIdKey) ||
      (window.crypto?.randomUUID
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random()}`);
    sessionStorage.setItem(tabIdKey, tabId);

    const user = store.state.auth.user;
    const userId = user?.id || user?.user_id || user?.email || "anonymous";
    const storageKey = `goldenkey-property-form:${userId}:${tabId}`;
    const hasLocalDraft = ref(Boolean(localStorage.getItem(storageKey)));

    const form = ref({
      title: "",
      description: "",
      property_type_id: null,
      location: "",
      price: 0,
      currency: "MZN",
      area: 0,
      bedroom_amount: 0,
      bathroom_amount: 0,
      garage_space: 0,
      condition_id: null,
      objective_id: null,
      images: [],
    });

    const propertyTypes = ref([]);
    const conditions = ref([]);
    const objectives = ref([]);
    const currencies = ref(["MZN", "USD", "EUR", "ZAR"]);

    const imagesPreviews = ref([]);
    const removedImages = ref([]);

    localStorage.removeItem(legacyStorageKey);

    // Elements produced by the active QEditor commands. Toolbar commands such
    // as undo, fullscreen and removeFormat do not add HTML elements.
    const allowedDescriptionTags = new Set([
      "P",
      "BR",
      "DIV",
      "SPAN",
      "FONT",
      "PRE",
      "CODE",
      "STRONG",
      "B",
      "EM",
      "I",
      "U",
      "S",
      "SUB",
      "SUP",
      "BLOCKQUOTE",
      "H1",
      "H2",
      "H3",
      "H4",
      "H5",
      "H6",
      "UL",
      "OL",
      "LI",
      "A",
      "HR",
    ]);

    const allowedStyleProperties = new Set([
      "text-align",
      "font-family",
      "font-size",
      "font-weight",
      "font-style",
      "text-decoration",
      "vertical-align",
    ]);

    const sanitizeDescription = (value) => {
      if (!value || typeof value !== "string") return "";

      const parsedDocument = new DOMParser().parseFromString(
        value,
        "text/html",
      );
      parsedDocument.body.querySelectorAll("*").forEach((element) => {
        if (!allowedDescriptionTags.has(element.tagName)) {
          element.replaceWith(...element.childNodes);
          return;
        }

        [...element.attributes].forEach((attribute) => {
          const attributeName = attribute.name.toLowerCase();
          if (element.tagName === "A" && attributeName === "href") return;
          if (
            element.tagName === "FONT" &&
            ["face", "size"].includes(attributeName)
          )
            return;
          if (
            ["P", "DIV", "H1", "H2", "H3", "H4", "H5", "H6"].includes(
              element.tagName,
            ) &&
            attributeName === "align" &&
            ["left", "center", "right", "justify"].includes(
              attribute.value.toLowerCase(),
            )
          ) {
            return;
          }
          if (attributeName === "style") {
            const safeStyle = [...element.style]
              .filter((property) => allowedStyleProperties.has(property))
              .map(
                (property) =>
                  `${property}: ${element.style.getPropertyValue(property)}`,
              )
              .join("; ");
            if (safeStyle) element.setAttribute("style", safeStyle);
            else element.removeAttribute("style");
            return;
          }
          element.removeAttribute(attribute.name);
        });

        if (element.tagName === "A") {
          const href = element.getAttribute("href");
          try {
            const url = new URL(href, window.location.origin);
            if (!["http:", "https:"].includes(url.protocol)) {
              element.removeAttribute("href");
            } else {
              element.setAttribute("href", url.href);
              element.setAttribute("target", "_blank");
              element.setAttribute("rel", "noopener noreferrer");
            }
          } catch (error) {
            element.removeAttribute("href");
          }
        }
      });

      return parsedDocument.body.innerHTML.trim();
    };

    const descriptionRule = (value) => {
      const sanitized = sanitizeDescription(value);
      const text = sanitized
        .replace(/<[^>]*>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .trim();
      return Boolean(text) || "Descrição é obrigatória";
    };

    const fileToDataUrl = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

    const dataUrlToFile = async (image) => {
      const response = await fetch(image.dataUrl);
      const blob = await response.blob();
      return new File([blob], image.name, {
        type: image.type || blob.type,
        lastModified: image.lastModified,
      });
    };

    const saveLocalForm = async () => {
      form.value.description = sanitizeDescription(form.value.description);
      const images = await Promise.all(
        form.value.images.map(async (image) => ({
          dataUrl: await fileToDataUrl(image),
          name: image.name,
          type: image.type,
          lastModified: image.lastModified,
        })),
      );

      localStorage.setItem(
        storageKey,
        JSON.stringify({ ...form.value, images }),
      );
    };

    const restoreLocalForm = async () => {
      const saved = localStorage.getItem(storageKey);
      if (!saved) return;

      try {
        const parsed = JSON.parse(saved);
        parsed.description = sanitizeDescription(parsed.description);
        const restoredImages = await Promise.all(
          (parsed.images || []).map(dataUrlToFile),
        );
        form.value = { ...form.value, ...parsed, images: restoredImages };
        restoredImages.forEach((file, index) => {
          imagesPreviews.value.push({
            url: URL.createObjectURL(file),
            name: `Imagem ${index + 1}`,
            file,
          });
        });
      } catch (error) {
        localStorage.removeItem(storageKey);
        console.error("Erro ao recuperar o formulário local:", error);
      }
    };

    onBeforeUnmount(() => {
      imagesPreviews.value.forEach((preview) => {
        URL.revokeObjectURL(preview.url);
      });
    });

    onMounted(() => {
      initializeForm();
    });

    async function initializeForm() {
      loader.value = true;
      try {
        await getStoreOptions();
        if (isEditing.value) await loadProperty();
        else await restoreLocalForm();
      } finally {
        loader.value = false;
      }
    }

    async function getStoreOptions() {
      await store.dispatch("imovel/getImovelOptions");
      propertyTypes.value =
        store.state.imovel.submitOptions.property_types || [];
      conditions.value = store.state.imovel.submitOptions.conditions || [];
      objectives.value = store.state.imovel.submitOptions.objectives || [];
    }

    const optionId = (value, options) => {
      if (value === null || value === undefined || value === "") return null;

      const rawValue = typeof value === "object" ? value.id : value;
      const option = options.find((item) => {
        if (String(item.id) === String(rawValue)) return true;

        const names = [item.name, item.title, item.label]
          .filter(Boolean)
          .map((name) => String(name).trim().toLowerCase());
        return names.includes(String(rawValue).trim().toLowerCase());
      });

      return option ? option.id : rawValue;
    };

    async function loadProperty() {
      loader.value = true;
      try {
        const property = await store.dispatch(
          "imovel/getImovelBySlug",
          propertySlug.value,
        );
        form.value = {
          ...form.value,
          title: property.title || "",
          description: sanitizeDescription(property.description || ""),
          property_type_id: optionId(
            property.property_type_id ?? property.property_type,
            propertyTypes.value,
          ),
          location: property.location || "",
          price: property.price ?? 0,
          currency: property.currency || "MZN",
          area: property.area ?? 0,
          bedroom_amount: property.bedroom_amount ?? 0,
          bathroom_amount: property.bathroom_amount ?? 0,
          garage_space: property.garage_space ?? 0,
          condition_id: optionId(
            property.condition_id ?? property.condition,
            conditions.value,
          ),
          objective_id: optionId(
            property.objective_id ?? property.objective,
            objectives.value,
          ),
          images: [],
        };

        const imageItems =
          property.images || property.imagens || property.image || [];
        imagesPreviews.value = imageItems.map((image, index) => ({
          id:
            typeof image === "object"
              ? image.id || image.image_id || image.image?.id || null
              : null,
          url:
            typeof image === "string"
              ? image
              : image.url || image.image_url || image.image?.url,
          name: `Imagem ${index + 1}`,
          existing: true,
        }));
      } catch (error) {
        await Swal.fire({
          icon: "error",
          title: "Erro ao carregar imóvel",
          text:
            error.response?.data?.message ||
            "Não foi possível carregar os dados do imóvel.",
        });
        router.push("/imoveis");
      } finally {
        loader.value = false;
      }
    }

    const onContinueStep1 = async () => {
      const valid = await step1FormRef.value.validate();
      if (!valid) return;

      savingStep1.value = true;
      try {
        await saveLocalForm();
        step.value = 2;
        hasLocalDraft.value = true;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text:
            error.response?.data?.message ||
            "Não foi possível guardar a informação básica. Tente novamente.",
        });
      } finally {
        savingStep1.value = false;
      }
    };

    const onContinueStep2 = async () => {
      const valid = await step2FormRef.value.validate();
      if (!valid) return;

      savingStep2.value = true;
      try {
        await saveLocalForm();
        step.value = 3;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text:
            error.response?.data?.message ||
            "Não foi possível guardar o preço e as características. Tente novamente.",
        });
      } finally {
        savingStep2.value = false;
      }
    };

    const onImageSelected = async (files) => {
      if (!files) return;

      const filesArray = Array.isArray(files) ? files : [files];

      for (const file of filesArray) {
        if (form.value.images.length >= 10) break;

        let correctName = file.name;

        if (file.__key) {
          const keyString = file.__key.toString();
          const match = keyString.match(
            /\d+(.+\.(jpg|jpeg|png|gif|webp))\d+$/i,
          );
          if (match) {
            correctName = match[1];
          }
        }

        const correctedFile = new File([file], correctName, {
          type: file.type,
          lastModified: file.lastModified,
        });

        form.value.images.push(correctedFile);

        const preview = {
          url: URL.createObjectURL(correctedFile),
          name: `Imagem ${form.value.images.length}`,
          file: correctedFile,
        };
        imagesPreviews.value.push(preview);

        showImageError.value = false;
      }

      tempImage.value = [];
      try {
        await saveLocalForm();
        hasLocalDraft.value = true;
      } catch (error) {
        Swal.fire({
          icon: "warning",
          title: "Não foi possível guardar localmente",
          text: "O armazenamento do navegador está cheio. Remova algumas imagens e tente novamente.",
        });
      }
    };

    const removeImage = async (index) => {
      const preview = imagesPreviews.value[index];
      if (preview.existing) {
        if (preview.id !== null && preview.id !== undefined) {
          removedImages.value.push(preview.id);
        }
      } else {
        URL.revokeObjectURL(preview.url);
        form.value.images.splice(form.value.images.indexOf(preview.file), 1);
      }
      imagesPreviews.value.splice(index, 1);
      imagesPreviews.value.forEach((preview, idx) => {
        preview.name = `Imagem ${idx + 1}`;
      });
      try {
        await saveLocalForm();
      } catch (error) {
        console.error("Erro ao actualizar o formulário local:", error);
      }
    };

    const onRejected = (rejectedEntries) => {
      rejectedEntries.forEach((entry) => {
        if (entry.failedPropValidation === "max-file-size") {
          console.log(`${entry.file.name} excede 5MB`);
        } else if (entry.failedPropValidation === "accept") {
          console.log(`${entry.file.name} tem formato inválido`);
        }
      });
    };

    const onPublish = async () => {
      if (!isEditing.value && form.value.images.length === 0) {
        showImageError.value = true;
        return;
      }

      publishing.value = true;
      loader.value = true;

      try {
        await saveLocalForm();
        const formData = new FormData();

        Object.keys(form.value).forEach((key) => {
          if (key !== "images") formData.append(key, form.value[key]);
        });
        form.value.images.forEach((image) => {
          formData.append("images[]", image);
        });

        if (isEditing.value) {
          [...new Set(removedImages.value)].forEach((imageId) =>
            formData.append("delete_image_ids[]", imageId),
          );
          console.log("IDs a remover:", [...new Set(removedImages.value)]); // debug
          await store.dispatch("imovel/updateImovel", {
            slug: propertySlug.value,
            formData,
          });
        } else {
          await store.dispatch("imovel/storeImovel", formData);
        }

        await Swal.fire({
          position: "top-end",
          icon: "success",
          title: isEditing.value
            ? "Imóvel actualizado com sucesso!"
            : "Imóvel publicado com sucesso!",
          showConfirmButton: false,
          timer: 1500,
        });

        resetLocalState();
        router.push("/imoveis");
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text:
            error.response?.data?.message ||
            "Erro ao publicar imóvel. Tente novamente.",
        });
      } finally {
        publishing.value = false;
        loader.value = false;
      }
    };

    const confirmCancel = async () => {
      const result = await Swal.fire({
        icon: "warning",
        title: isEditing.value
          ? "Descartar alterações?"
          : localStorage.getItem(storageKey)
          ? "Descartar este imóvel?"
          : "Sair sem guardar?",
        text: isEditing.value
          ? "As alterações que fez serão descartadas."
          : localStorage.getItem(storageKey)
          ? "Tudo o que preencheu até agora será apagado permanentemente."
          : "Ainda não guardou nenhuma informação.",
        showCancelButton: true,
        confirmButtonText: "Sim, descartar",
        cancelButtonText: "Continuar a preencher",
        confirmButtonColor: "#d33",
      });

      if (!result.isConfirmed) return;

      resetLocalState();
      router.push("/imoveis");
    };

    const resetLocalState = () => {
      imagesPreviews.value.forEach((preview) => {
        URL.revokeObjectURL(preview.url);
      });

      step.value = 1;
      form.value = {
        title: "",
        description: "",
        property_type_id: null,
        location: "",
        price: 0,
        currency: "MZN",
        area: 0,
        bedroom_amount: 0,
        bathroom_amount: 0,
        garage_space: 0,
        condition_id: null,
        objective_id: null,
        images: [],
      };
      imagesPreviews.value = [];
      removedImages.value = [];
      tempImage.value = null;
      showImageError.value = false;
      localStorage.removeItem(storageKey);
      hasLocalDraft.value = false;
    };

    return {
      editor,
      isMobile,
      isEditing,
      step,
      stepperRef,
      step1FormRef,
      step2FormRef,
      form,
      descriptionRule,
      savingStep1,
      savingStep2,
      publishing,
      loader,
      tempImage,
      showImageError,
      hasLocalDraft,
      storageKey,
      propertyTypes,
      conditions,
      objectives,
      currencies,
      imagesPreviews,
      onContinueStep1,
      onContinueStep2,
      onImageSelected,
      removeImage,
      onRejected,
      onPublish,
      confirmCancel,
    };
  },
};
</script>

<style scoped>
/* ── Page ─────────────────────────────────────────────── */
.form-page {
  background: #f4f6fb;
  min-height: 100vh;
}

/* ── Page header ──────────────────────────────────────── */
.page-header {
  background: #0d1b2a;
  padding: 20px 24px;
}
.page-header-inner {
  display: flex;
  align-items: center;
  max-width: 860px;
  margin: 0 auto;
}
.back-btn {
  color: rgba(255, 255, 255, 0.7) !important;
  background: rgba(255, 255, 255, 0.08) !important;
}
.back-btn:hover {
  background: rgba(255, 255, 255, 0.14) !important;
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.2;
}
.page-subtitle {
  font-size: 12px;
  color: rgba(212, 175, 55, 0.75);
  letter-spacing: 0.4px;
  margin-top: 2px;
}

/* ── Form wrapper ─────────────────────────────────────── */
.form-wrapper {
  max-width: 860px;
  margin: 32px auto;
  padding: 0 16px 48px;
}
.form-card {
  border-radius: 16px;
  border: 1px solid #e8ecf4;
  box-shadow: 0 4px 24px rgba(13, 27, 42, 0.07);
  overflow: hidden;
  background: #ffffff;
}

/* ── Stepper ──────────────────────────────────────────── */
.property-stepper {
  box-shadow: none;
}
.property-stepper :deep(.q-stepper__tab--active .q-stepper__dot) {
  background: #0d1b2a;
  color: #d4af37;
}
.property-stepper :deep(.q-stepper__tab--done .q-stepper__dot) {
  background: #d4af37;
  color: #0d1b2a;
}

.section-body {
  padding: 28px 32px 4px;
}
.section-sub {
  font-size: 12px;
  color: #94a3b8;
}
.form-field {
  margin-bottom: 4px;
}
.description-field {
  min-width: 0;
}
.description-field :deep(.q-field__control),
.description-field :deep(.q-field__control-container),
.description-field :deep(.q-field__native) {
  min-width: 0;
  width: 100%;
}
.description-editor {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}
.description-editor :deep(.q-editor__toolbar) {
  display: flex;
  flex-wrap: wrap;
  height: auto;
  min-width: 0;
  overflow: hidden;
}
.description-editor :deep(.q-editor__toolbar-group) {
  display: flex;
  flex-wrap: wrap;
  min-width: 0;
}
.description-editor :deep(.q-editor__content) {
  min-height: 150px;
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
  overflow-wrap: anywhere;
}

/* ── Upload zone ──────────────────────────────────────── */
.upload-zone {
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  transition: border-color 0.2s, background 0.2s;
  cursor: pointer;
  background: #f8fafc;
}
.upload-zone:hover:not(.upload-zone--disabled) {
  border-color: #d4af37;
  background: rgba(212, 175, 55, 0.04);
}
.upload-zone--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.upload-input {
  width: 100%;
}
.upload-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  pointer-events: none;
}
.upload-icon {
  color: #d4af37;
  margin-bottom: 8px;
}
.upload-text {
  font-size: 14px;
  font-weight: 600;
  color: #475569;
}
.upload-hint {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 4px;
}

/* ── Image previews ───────────────────────────────────── */
.preview-card {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}
.preview-img {
  border-radius: 10px;
}
.preview-overlay {
  position: absolute;
  top: 6px;
  right: 6px;
  opacity: 0;
  transition: opacity 0.2s;
}
.preview-card:hover .preview-overlay {
  opacity: 1;
}
.preview-label {
  font-size: 10px;
  color: #64748b;
  text-align: center;
  padding: 4px 6px;
  background: #f8fafc;
}

/* ── Actions ──────────────────────────────────────────── */
.form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 20px 32px 28px;
  border-top: 1px solid #f0f4fa;
  background: #fafbfd;
}
.form-actions--step {
  margin-top: 16px;
}
.action-btn {
  border-radius: 10px;
  font-weight: 600;
  font-size: 13px;
  padding: 8px 20px;
  letter-spacing: 0.3px;
}
.action-btn--cancel {
  color: #94a3b8 !important;
}
.action-btn--cancel:hover {
  background: #f1f5f9 !important;
  color: #64748b !important;
}
.action-btn--reset {
  color: #04203d !important;
  background: #c8ac0f !important;
}
.action-btn--reset:hover {
  background: #f1f5f9 !important;
}
.action-btn--submit {
  background: #0d1b2a !important;
  color: #d4af37 !important;
  padding: 10px 28px;
}
.action-btn--submit:hover {
  background: #162333 !important;
}

/* ── Responsividade (mobile) ─────────────────────────────── */
@media (max-width: 599px) {
  .page-header {
    padding: 14px 16px;
  }
  .page-title {
    font-size: 17px;
  }
  .page-subtitle {
    font-size: 11px;
  }

  .form-wrapper {
    margin: 16px auto;
    padding: 0 8px 32px;
  }
  .form-card {
    border-radius: 12px;
  }

  .section-body {
    padding: 20px 16px 4px;
  }
  .description-field :deep(.q-field__control) {
    min-height: 0;
    height: auto;
  }
  .description-editor :deep(.q-editor__toolbar) {
    padding: 4px;
  }
  .description-editor :deep(.q-editor__toolbar-group) {
    margin: 0;
  }
  .description-editor :deep(.q-btn) {
    min-width: 28px;
    min-height: 28px;
    padding: 4px;
  }
  .description-editor :deep(.q-editor__content) {
    min-height: 140px;
    max-height: 260px;
  }
  .section-sub {
    font-size: 11px;
  }

  .upload-prompt {
    padding: 24px 12px;
  }

  .form-actions {
    padding: 16px 16px 20px;
  }
  .form-actions--step {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .action-btn {
    width: 100%;
    justify-content: center;
    padding: 10px 16px;
  }
  .action-btn--submit {
    order: 1;
    padding: 12px 16px;
  }
}
</style>
